import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CIRuleActionsService } from '../../services/ci-rule-actions.service';
import { CI_RULE_ACTIONS_API_ACTIONS } from '../actions/ci-rule-actions.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class CIRuleActionsEffects {
  constructor(
    private readonly actions: Actions,
    private readonly ciRuleActionsService: CIRuleActionsService,
  ) {}

  getCIRuleActions$ = createEffect(() =>
    this.actions.pipe(
      ofType(CI_RULE_ACTIONS_API_ACTIONS.get),
      switchMap(() =>
        this.ciRuleActionsService.getCIRuleActions().pipe(
          map((data) => CI_RULE_ACTIONS_API_ACTIONS.success({ data })),
          catchError((err: HttpErrorResponse) => of(CI_RULE_ACTIONS_API_ACTIONS.error(err))),
        ),
      ),
    ),
  );
}
